import React from 'react'
import OrgLevels from '../../../components/OrgLevels'

const OrgLevelsPage = () => {
    return (
        <div class="w-full">
            <OrgLevels />
        </div>
    )
}

export default OrgLevelsPage
